function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Temperature"
}, /*#__PURE__*/React.createElement("title", null, "VF_alarm_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 0c-27.4 0-49.6 22.2-49.6 49.6v184.3c0 27.3 22.3 49.6 49.6 49.6s49.6-22.2 49.6-49.6V49.6c0-27.4-22.2-49.6-49.6-49.6zM163 233.9c0 11.7-9.5 21.2-21.3 21.2s-21.3-9.5-21.3-21.2v-21.4h21.3v-14.2h-21.3V170h21.3v-14.2h-21.3v-28.4h21.3v-14.2h-21.3V85h21.3V70.8h-21.3V49.6c0-11.7 9.5-21.2 21.3-21.2S163 37.9 163 49.6v184.3z"
}))));